export const colors = [
  { name: 'Зеленый', hex: '#EDF7D1' },
  { name: 'Оранжевый', hex: '#FFEFE2' },
  { name: 'Желтый', hex: '#FBF3DE' },
  { name: 'Розовый', hex: '#FFEBEF' },
  { name: 'Синий', hex: '#EBF1FC' },
  { name: 'Бежевый', hex: '#F1EEEA' },
  { name: 'Фиолетовый', hex: '#F1ECFF' },
];
